function swipers() {

    if ( $j('#swiper-blog').length ) {

        var mySwiper = new Swiper ('#swiper-blog .swiper-container', {
            loop: true,
            lazy: false,
            parallax: true,
            autoheight: false,
            grabCursor: true,
            centeredSlides: true,
            //watchSlidesVisibility: true,
            //watchSlidesProgress: true,
            //mousewheel: true,
            //direction: 'vertical',
            //effect: 'fade', // coverflow cube
            //freeMode: true,
            pagination: {
                el: '#swiper-blog .swiper-pagination',
                //type: 'progressbar',
                //dynamicBullets: true,
                clickable: true,
                renderBullet: function (index, className) {
                    index = index + 1;
                    var name = index;
                    if(index<10) {
                        //name = '0'+index;
                    }
                    return '<span class="' + className + '">' + name + '</span>';
                },
            },
            navigation: {
                nextEl: '#swiper-blog .swiper-next',
                prevEl: '#swiper-blog .swiper-prev',
            },
            keyboard: {
                enabled: true,
            },
            autoplay: {
                delay: 5000
            }
        })
    }


    if ( $j('#swiper-home').length ) {

        var mySwiper = new Swiper ('#swiper-home .swiper-container', {
            //effect: 'fade', // coverflow cube
            //freeMode: true,
            loop: true,
            lazy: false,
            parallax: true,
            autoheight: true,
            grabCursor: true,
            centeredSlides: true,
            //watchSlidesVisibility: true,
            //watchSlidesProgress: true,
            //mousewheel: true,
            //direction: 'vertical',
            pagination: {
                el: '#swiper-home .swiper-pagination',
                //type: 'progressbar',
                //dynamicBullets: true,
                clickable: true,
                renderBullet: function (index, className) {
                    index = index + 1;
                    var name = index;
                    if(index<10) {
                        //name = '0'+index;
                    }
                    return '<span class="' + className + '">' + name + '</span>';
                },
            },
            navigation: {
                nextEl: '#swiper-home .swiper-next',
                prevEl: '#swiper-home .swiper-prev',
            },
            keyboard: {
                enabled: true,
            },
            autoplay: {
                delay: 5000
            }
        })

    }


    if ( $j('#swiper-sidebar').length ) {

        var mySwiper = new Swiper ('#swiper-sidebar .swiper-container', {

            //effect: 'fade', // coverflow cube
            //loop: true,
            //lazy: true,
            navigation: {
                nextEl: '#swiper-sidebar .swiper-button-next',
                prevEl: '#swiper-sidebar .swiper-button-prev',
            },
            pagination: {
                el: '#swiper-sidebar .swiper-pagination',
                type: 'progressbar',
                dynamicBullets: true,
            },
            keyboard: {
                enabled: true,
            },
            //watchSlidesVisibility: true,
            //watchSlidesProgress: true,
            //mousewheel: true,
            //autoHeight: true,
            grabCursor: true,
            //parallax: true,
            //freeMode: true,
            autoplay: false,
            slidesPerView: 1,
            spaceBetween: 10,
            autoplay: {
                delay: 5000
            },
            // Responsive breakpoints
            breakpoints: {
                // when window width is <= 320px
                500: {
                    slidesPerView: 1,
                },
                // when window width is <= 480px
                770: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
            }

        });

    }


}
